import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom-v5-compat';

import { claimTabLinkProps } from '../../utils/claim-tab-helpers';
import BasicLink from '../web-component-wrappers/BasicLink';

function ReviewRequestsAlert({ useVaTabs = false }) {
  const { id: claimId } = useParams();

  return (
    <va-alert status="warning" class="vads-u-margin-bottom--4">
      <h3 slot="headline">Review your requests</h3>
      <p>
        You may have evidence requests you haven't responded to yet. Review them
        before uploading additional evidence here.
      </p>
      <BasicLink
        action
        disable-analytics
        {...(useVaTabs
          ? claimTabLinkProps('status', { claimId })
          : { path: '../status' })}
        text="Review requests"
        type="secondary"
      />
    </va-alert>
  );
}

ReviewRequestsAlert.propTypes = {
  useVaTabs: PropTypes.bool,
};

export default ReviewRequestsAlert;
